export const TIMER_ANIMATION_DELAY = 2;
export const SKIP_ANIMATION_DELAY = 1;
export const GINNIE_ANIMATION_DELAY = 1;
